"use client";
import {
  GameAlignment,
  GamePeriod,
  GameStatus,
  isGameClosed,
  isGameException,
  ScoreboardGame,
} from "common";
import React, { createContext, useContext, useState, useRef, useEffect, useMemo } from "react";
import {
  DriveStatus,
  getDriveStatus,
  LiveGame,
} from "@/utils/game";
import { createGameDetailSlug } from "../url";
import { useScoreboardUpdate } from "../hooks/scoreboard-update";
import assert from "assert";

export interface GameContextType {
  game: ScoreboardGame;
  slug: string;
  prevStatus?: GameStatus;
  showCountdown: boolean;
  setShowCountdown: React.Dispatch<React.SetStateAction<boolean>>;
  startsNow: boolean;
  setStartsNow: React.Dispatch<React.SetStateAction<boolean>>;
  isLive: boolean;
  currentPeriod: GamePeriod | null;
  closed: boolean;
  exception: boolean;
  winner: GameAlignment | null;
  driveStatus: DriveStatus | undefined;
}

const GameContext = createContext<GameContextType | null>(null);

export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error("useGame must be used within a GameProvider");
  }
  return context;
};

export function GameProvider({
  game,
  children,
}: {
  game: ScoreboardGame;
  children: React.ReactNode;
}) {
  console.log("game provider re-render");
  assert(game, "A game must be provided");
  const [data, setData] = useState<ScoreboardGame>(game);
  // useScoreboardUpdate(data, setData);
  const [prevStatus, setPrevStatus] = useState<GameStatus | undefined>(undefined);
  const [showCountdown, setShowCountdown] = useState<boolean>(false);
  const [startsNow, setStartsNow] = useState<boolean>(false);
  const statusRef = useRef<GameStatus | undefined>(undefined);
  
  useEffect(() => {
    setData(game);
  }, [game]);

  useEffect(() => {
    if (data.status !== statusRef.current) {
      setPrevStatus(statusRef.current);
      statusRef.current = data.status;
    }
  }, [data.status]);

  // const live = isGameLive(data, prevStatus);

  const exception = isGameException(data.status);
  const closed = isGameClosed(data.status);
const winner = useMemo(() => {
  if (!exception && closed) {
    if (data.awayScore > data.homeScore) return "away";
    if (data.homeScore > data.awayScore) return "home";
    return null;
  }
  return null;
}, [data.awayScore, data.homeScore, exception, closed]);
  const driveStatus = getDriveStatus(data);
  const isLive = data.status === "InProgress";
  const currentPeriod = isLive && data.period ? data.period[data.currentPeriodIdx] : null;
  console.log("periods from game", data.period);
  return (
    <GameContext.Provider
      value={{
        game: data,
        slug: createGameDetailSlug(data.league, data.id),
        prevStatus,
        showCountdown,
        setShowCountdown,
        startsNow,
        setStartsNow,
        isLive,
        currentPeriod,
        exception,
        closed,
        winner,
        driveStatus,
      }}
    >
      {children}
    </GameContext.Provider>
  );
}
